import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment as ENV } from './../../../environments/environment';
import * as apiUrl from '../constants/api-urls';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PriceRecommenderService {
  api_url = `${ENV.API_ENDPOINT}`;
  constructor(private http: HttpClient) { }

  validateOptimiser(){
    let url = this.api_url + apiUrl.price_recommender.validateOptimiser;
    return this.http.post(url,{})
  }

  /** To get the list of scenarios */
  getScenarioList(params: any) {
    let url = this.api_url + apiUrl.price_recommender.getScenarios;
    return this.http.post(url, params)
  }

  /** get list of approvers for filters */
  getApproversList() {
    let url = this.api_url + apiUrl.price_recommender.approversList;
    return this.http.get(url)
  }

  /** get list of status for filters */
  getStatusList() {
    let url = this.api_url + apiUrl.price_recommender.statusList;
    return this.http.get(url)
  }

  /** get list of constraint for popup */
  getConstraintList(payload: any) {
    let url = this.api_url + apiUrl.price_recommender.constraintList;
    return this.http.post(url, payload);
  }

  /*get list of new recommender Category*/
  getPriceRecommenderCaterogy(){
    let url = this.api_url + apiUrl.price_recommender.recommenderCaterogyList;
    return this.http.get(url)
  }

  /*get item list on based of category id in new recommender*/
  getProductListData(reqPayload:any){
    let url = this.api_url + apiUrl.price_recommender.recommenderSKUList;
    return this.http.post(url,reqPayload)
  }

  getScenarioPriceRecommendationHeaderDetails(payload: any){
    let url = this.api_url + apiUrl.price_recommender.priceRecommenderListHeaders;
    return this.http.post(url, payload);
  }
  
  getScenarioPriceRecommendationPriceTierDetails(payload: any){
    let url = this.api_url + apiUrl.price_recommender.priceRecommenderPriceTierTable;
    return this.http.post(url, payload);
  }
  
  getScenarioPriceRecommendationEstimatedImpactDetails(payload: any){
    let url = this.api_url + apiUrl.price_recommender.estimatedImpact;
    return this.http.post(url, payload);
  }
  
  getScenarioPriceRecommendationSKUEstimatedImpactDetails(payload: any){
    let url = this.api_url + apiUrl.price_recommender.estimatedImpactPriceBand;
    return this.http.post(url, payload);
  }
  
  getScenarioPriceRecommendationOriginalImpactDetails(payload: any){
    let url = this.api_url + apiUrl.price_recommender.originalImpact;
    return this.http.post(url, payload);
  }
  
  getScenarioPriceRecommendationSKUOriginalImpactDetails(payload: any){
    let url = this.api_url + apiUrl.price_recommender.originalImpactPriceBand;
    return this.http.post(url, payload);
  }

  getSKUDetails(payload:any){
    let url = this.api_url + apiUrl.price_recommender.skuDetails;
    return this.http.post(url, payload)
  }
  
  getSKUDetailsCount(payload:any){
    let url = this.api_url + apiUrl.price_recommender.skuDetailsCount;
    return this.http.post(url, payload)
  }

  getContraintsCall(){
    let url = this.api_url + apiUrl.price_recommender.constraintsGetData;
    return this.http.get(url)
  }

  getConstraintListData(constraintCatId:any){
    let url = this.api_url + apiUrl.price_recommender.constraintsDrillDown+'?constraint_category='+constraintCatId;
    return this.http.get(url)
  }

  downloadPriceRecommender(){
    let url = this.api_url + apiUrl.price_recommender.downloadPriceRecommender;
    const httpOptions = {
      responseType: 'blob' as 'json',
    };
    return this.http.get(url, httpOptions);
  }

  getRequestIdForNewPriceRecommender(){
    let url = this.api_url + apiUrl.price_recommender.initiateNewPriceRecommender;
    return this.http.get(url)
  }

  getScenarioIdFromOptimizer(payload:any){
    let url = this.api_url + apiUrl.price_recommender.generateOptimizerInRecommenderList;
    return this.http.post(url, payload)
  }

  uploadPriceRecommender(formData:FormData){
    let url = this.api_url + apiUrl.price_recommender.uploadPriceRecommender;
    return this.http.post(url,formData)
  }

  downloadConstraintsRules(payload:any){
    let url = this.api_url + apiUrl.price_recommender.downloadConstraintRules;
    const httpOptions = {
      responseType: 'blob' as 'json',
    };
    return this.http.post(url, payload, httpOptions);
  }

  getGraphDroddownData(){
    let  url = this.api_url + apiUrl.recommendation.graphDropdownData;
    return this.http.get(url);
  }

  /** to get chart data */
  getGraphData(payload: any) {
    let  url = this.api_url + apiUrl.recommendation.graphData;
    return this.http.post(url, payload);
  }

  downloadRecommenderErrorLogs(payload:any){
    let url = this.api_url + apiUrl.price_recommender.downloadConstraintRules;
    const httpOptions = {
      responseType: 'blob' as 'json',
    };
    return this.http.post(url,payload, httpOptions);
  }

  getPriceBandConfig(){
    let url = this.api_url + apiUrl.price_band_config.get_price_band_config_data;
    return this.http.get(url)
  }

  getPriceBandConfigDropdown(){
    let url = this.api_url + apiUrl.price_band_config.get_dropdown_data;
    return this.http.get(url)
  }

  savePriceBandConfig(payload:any){
    let url = this.api_url + apiUrl.price_band_config.save_price_band_config_data;
    return this.http.post(url, payload)
  }

  checkPriceRecommendation(){
    let url = this.api_url + apiUrl.price_band_config.check_price_recommendation;
    return this.http.post(url,{});
  }

  viewPriceBandConfig(payload:any){
    let url = this.api_url + apiUrl.price_band_config.view_price_band_config;
    return this.http.post(url, payload)
  }

  getBusinessObjective(){
    let url = this.api_url + apiUrl.price_recommender.businessObjective;
    return this.http.get(url)
  }

}
